export { SegmentedControl } from './SegmentedControl';
export type { ISegmentedControlOption, ISegmentedControlProps } from '@shared/types';
